module.exports = __webpack_public_path__ + "static/media/mute.d79fd681.svg";